import type { ServiceResponse } from './types';
import { apiRequest } from '../utils/api';

// Backend response types
interface ContactMessageResponseDto {
  _id: string;
  id: string;
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

// Frontend types
export interface ContactMessage {
  id: string;
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
  status: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
}

class ContactService {
  private readonly baseUrl = '/contact-messages';

  // Transform backend response to frontend format
  private transformMessage(dto: ContactMessageResponseDto): ContactMessage {
    return {
      id: dto.id || dto._id,
      name: dto.name,
      email: dto.email,
      phone: dto.phone,
      subject: dto.subject,
      message: dto.message,
      status: dto.status,
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt),
    };
  }

  // Submit contact form
  async submitContactForm(data: ContactFormData): Promise<ServiceResponse<ContactMessage>> {
    try {
      const response = await apiRequest<ContactMessageResponseDto>(
        this.baseUrl,
        {
          method: 'POST',
          body: JSON.stringify(data),
        }
      );

      return {
        success: true,
        data: this.transformMessage(response),
        message: 'Your message has been sent successfully',
      };
    } catch (error) {
      console.error('Error submitting contact form:', error);
      return {
        success: false,
        data: {} as ContactMessage,
        error: error instanceof Error ? error.message : 'Failed to send message',
      };
    }
  }
}

export const contactService = new ContactService();